import { get, map } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';
import styles from './Deliveries.module.css';
import Button from '../ReusableComponents/Button/Button';

const useStyles = makeStyles()((theme) => ({
  checkin: {
    background: get(theme, 'palette.primary.main'),
    '&:hover': {
      background: get(theme, 'palette.primary.dark'),
    },
  },
  remove: {
    color: get(theme, 'palette.secondary.main'),
    cursor: 'pointer',
    '&:hover': {
      color: get(theme, 'palette.secondary.dark'),
    },
  },
  save: {
    color: get(theme, 'palette.success.main'),
    cursor: 'pointer',
    '&:hover': {
      color: get(theme, 'palette.success.dark'),
    },
  },
}));

export default function DeliveryCheckIn(props) {
  const { classes } = useStyles();
  const { onSaveDelivery, onCheckIn, delivery, disabled = false } = props;
  const [editing, setEditing] = useState(false);
  const [deliveredAt, setDeliveredAt] = useState(delivery.delivered_at);
  const purchaseOrderIdentifiers = map(delivery.purchase_orders, 'po_number');

  const updateDeliveredAt = ({ target: { value } }) => {
    const [hours, minutes] = value.split(':');
    const date = moment
      .utc(deliveredAt)
      .startOf('day')
      .add(hours, 'hours')
      .add(minutes, 'minutes')
      .toDate();

    setDeliveredAt(date);
  };

  function checkIn(date) {
    onCheckIn(delivery.id, date || deliveredAt);
    setEditing(false);
    setDeliveredAt(date || deliveredAt);
  }

  function removeDeliveredAt() {
    onSaveDelivery(
      delivery.id,
      { id: delivery.id, delivered_at: null },
      purchaseOrderIdentifiers,
    );
    setDeliveredAt(null);
    setEditing(false);
  }

  function onEnter(e) {
    if (e.key === 'Enter' && editing) checkIn();
  }

  return (
    <div className={styles.checkInContainer}>
      {!delivery.delivered_at ? (
        <Button
          variant="contained"
          color="white"
          small
          disabled={disabled}
          className={classes.checkin}
          onClick={() =>
            checkIn(
              moment
                .utc(
                  moment
                    .utc(delivery.starts_at)
                    .startOf('day')
                    .add(
                      moment().diff(moment().startOf('day'), 'minutes'),
                      'minutes',
                    )
                    .format('LLLL'),
                  'LLLL',
                )
                .format(),
            )
          }
        >
          Check In
        </Button>
      ) : (
        <div className={styles.checkInDetails}>
          {!editing ? (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <span onKeyDown={onEnter} onClick={() => setEditing(true)}>
              {moment.utc(delivery.delivered_at).format('hh:mm A')}
            </span>
          ) : (
            <TextField
              variant="standard"
              id="block-modal-ends-at"
              type="time"
              name="delivered_at"
              disabled={disabled}
              value={
                deliveredAt ? moment.utc(deliveredAt).format('HH:mm') : '00:00'
              }
              margin="normal"
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 60 }}
              onChange={updateDeliveredAt}
            />
          )}

          {!editing ? (
            ''
          ) : (
            <div>
              <Check
                className={classes.save}
                onClick={() => checkIn()}
                disabled={disabled}
              />
              <Close
                className={classes.remove}
                disabled={disabled}
                onClick={() => removeDeliveredAt()}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

DeliveryCheckIn.propTypes = {
  onSaveDelivery: PropTypes.func.isRequired,
  onCheckIn: PropTypes.func.isRequired,
  delivery: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
};
